import type { Transformer } from '../DataProvider';
import type {
  Account,
  FontFamily,
  FontSource,
  GlobalConfig,
  RawAccount,
  RawFontFamily,
  RawGlobalConfig,
} from './types';

const transformFontFamilies = (fontFamilies: (RawFontFamily | null)[]): FontFamily[] =>
  fontFamilies
    .filter((rawFontFamily): rawFontFamily is RawFontFamily => !!rawFontFamily)
    .map((rawFontFamily) => ({
      id: rawFontFamily.id,
      name: rawFontFamily.name,
      font: {
        stretch: rawFontFamily.fontstretch,
        weight: rawFontFamily.fontweight,
        style: rawFontFamily.fontstyle,
      },
      sources: (rawFontFamily.fonts ?? []).filter(
        (fontSource): fontSource is FontSource => !!fontSource,
      ),
    }));

const transformAccount = (rawAccount: RawAccount): Account => ({
  id: rawAccount.id,
  name: rawAccount.name,
  fontFamilies: transformFontFamilies(rawAccount.fontFamilies ?? []),
});

export const transformGlobal: Transformer<RawGlobalConfig, GlobalConfig> = (data) => {
  return {
    id: data.id,
    version: data.version ?? null,
    account: data.account ? transformAccount(data.account) : null,
    accountPrefix: data.accountPrefix ?? null,
    admCreative: data.admCreative ?? null,
    campaign: data.campaign ?? null,
    country: data.country ?? null,
    everyTrackingPixel: data.everyTrackingPixel ?? null,
    linkoutTrackingPixel: data.linkoutTrackingPixel ?? null,
    meta: data.meta ?? {},
    uniqueTrackingPixel: data.uniqueTrackingPixel ?? null,
    watchLater: data.watchLater ?? null,
    grids: data.grids,
    trackerUrl: data.trackerUrl,
    reportingSchemaVersion: data.reportingSchemaVersion,
  };
};
